import { render, staticRenderFns } from "./CountryIndicesTab.vue?vue&type=template&id=a74402d2&"
import script from "./CountryIndicesTab.vue?vue&type=script&lang=js&"
export * from "./CountryIndicesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports